import { EmbeddedCode } from '../../entities/shared/code';
import { Address } from '../../entities/shared/address';
import { CodeStatus, EmbeddedCodeLike } from '../../entities/shared/code';
import { ContactSummary } from '../../entities/contact/contact';
import { Entity } from '../../entities/entity';
import { JobPolicyThresholds } from '../../entities/policies/job.policy.thresholds';
import { Label } from '../../entities/shared/label';
import { PrimaryTechnician } from '../../entities/job/workorder';
import { Site } from '../../entities/shared/site';
import { StageResourceMode } from '../../entities/settings/general.settings';

export interface WorkOrderPatchRequest {
    jobId?: string;
    workOrderId: string;
    updatedAt?: string;
    name?: string;
    dueDate?: Date;
    startDate?: Date;
    completedDate?: Date;
    finalisedDate?: Date;
    codes?: EmbeddedCode[];
    claimCodes?: EmbeddedCode[];
    customFields?: any;
    alternateSite?: Site;
    alternateContact?: ContactSummary;
    alternateAddress?: Address;
    subcontractor?: PrimaryTechnician;
    isMovingCodes?: boolean;
    systemLabels?: Entity[];
    defectCount?: number;
    thresholds?: JobPolicyThresholds;
    pricebook?: Entity;
    sortOrder?: string;
    resourceMode?: StageResourceMode;
}

export interface WorkOrderDeleteCodesRequest {
    jobId?: string;
    workOrderId: string;
    updatedAt?: string;
    codes: EmbeddedCode[];
    useClaimCode?: boolean;
}

export interface WorkOrderMoveCodesRequest {
    jobId?: string; // Optional - derived from 'from' stage if not provided
    from: string;
    to: string;
    codes?: EmbeddedCode[];
}

export interface WorkOrderPurchaseCodesRequest {
    jobId: string;
    codes?: string[];
}

export interface WorkOrderCodesBulkActionRequest {
    jobId?: string;
    workOrderId: string;
    codes?: EmbeddedCode[];
}

export interface WorkOrderPatchField {
    name?: string;
    dueDate?: Date;
    startDate?: Date;
    completedDate?: Date;
    finalisedDate?: Date;
    alternateSite?: Site;
    alternateContact?: ContactSummary;
    alternateAddress?: Address;
    subcontractor?: PrimaryTechnician;
    labels?: Label[];
    resources?: PrimaryTechnician[];
    codes?: EmbeddedCode[];
    claimCodes?: EmbeddedCode[];
    workCategory?: Label;
    defectCount?: number;
}

export enum WorkOrderUpdatedField {
    Name = 'name',
    DueDate = 'dueDate',
    StartDate = 'startDate',
    CompletedDate = 'completedDate',
    FinalisedDate = 'finalisedDate',
    Codes = 'codes',
    ClaimCodes = 'claimCodes',
    CustomFields = 'customFields',
    AlternateSite = 'alternateSite',
    AlternateContact = 'alternateContact',
    AlternateAddress = 'alternateAddress',
    Subcontractor = 'subcontractor',
    Labels = 'labels',
    WorkCategory = 'workCategory',
    DefectCount = 'defectCount',
    BuyLimit = 'thresholds.buyLimit',
    AllowAddItems = 'thresholds.allowAddItems',
    Pricebook = 'pricebook',
    SortOrder = 'sortOrder',
}

export const WorkOrderAllowUpdateFields = [
    'name',
    'dueDate',
    'startDate',
    'completedDate',
    'completedBy',
    'finalisedDate',
    'finalisedBy',
    'codes',
    'claimCodes',
    'customFields',
    'alternateSite',
    'alternateAddress',
    'alternateContact',
    'subcontractor',
    'labels',
    'schedulingTags',
    'workCategory',
    'systemLabels',
    'claimCodes',
    'defectCount',
    'estimatedDuration',
    'stageOwner',
    'thresholds',
    'theme',
    'pricebook',
    'sortOrder',
    'resourceMode',
];
